import { SORTING } from "../../../../constants/sorting";
import { getSortingType } from "../../../../utils/ordering";

export const getDataTypeFromDataColumn = data => {
	const stats = {
		[SORTING.TYPES.STRING]: 0,
		[SORTING.TYPES.NUMBER]: 0,
		[SORTING.TYPES.DATE]: 0,
		[SORTING.TYPES.BOOLEAN]: 0
	};

	data.forEach(value => {
		const sortingType = getSortingType(value);

		if (sortingType !== SORTING.TYPES.ANY) {
			stats[sortingType]++;
		}
	});

	const winner = Object.entries(stats).reduce(
		(oldValue, newValue) => {
			return newValue[1] > oldValue[1] ? newValue : oldValue;
		},
		[SORTING.TYPES.ANY, 0]
	);

	return winner[0];
};
